import Page from "components/Page";
import { Props } from "./InboundLogs";
import { lazyWithRetry } from "helpers/lazyWithRetry";

const InboundLogs = lazyWithRetry(() => import("./InboundLogs"));

export default (props: Props) => (
  <Page>
    <InboundLogs {...props} />
  </Page>
);
